export function limitChar(str: string, length: number) {
  if (str && typeof str === 'string' && length > 6 && str.length > length)
    str = `${str.substring(0, length - 3)}...`;
  // console.log('string char', str);
  return str;
}
